import { SkeletonWithoutBreadcrumbs } from '@townsquare/griffin-main-header/skeleton';
import Loadable from '@townsquare/loadable';
import { appsRoute as appsRouteDefinition } from '@townsquare/routes/apps-view';

import { AppsViewRedesignLoadingSkeleton } from './components/AppsViewRedesignLoadingSkeleton';

appsRouteDefinition.component = Loadable({
	loader: () => import(/* webpackChunkName: "apps-view" */ './components/AppsView'),
	loading: AppsViewRedesignLoadingSkeleton,
});

appsRouteDefinition.header = Loadable({
	loader: () => import(/* webpackChunkName: "apps-header" */ './components/AppsHeader'),
	loading: SkeletonWithoutBreadcrumbs,
});

export const appsRoute = appsRouteDefinition;
